import styled from 'styled-components'

import { Breakpoint } from '@procsea/design-system'

export const LoaderContainer = styled.div<{ activeBreakpoint: Breakpoint }>`
  & {
    align-items: center;
    display: flex;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background-color: white;
    z-index: 10;

    ${props =>
      props.activeBreakpoint === Breakpoint.IS_MOBILE &&
      `
      top: ${props.theme.dimensions.mobileHeaderHeight};
    `}

    ${props =>
      props.activeBreakpoint !== Breakpoint.IS_MOBILE &&
      props.activeBreakpoint !== Breakpoint.IS_TABLET &&
      `
      left: ${props.theme.menu.dimensions.desktop.width};
    `}
  }
`
